/** Base Url for the Valhalla's API */
const baseUrl = 'https://valhalla.pt.appstack.me/'

/** Valhalla endpoint to get a route */
export const VALHALLA_ROUTE_ENDPOINT = baseUrl + 'route'

/** Valhalla endpoint to get an optimized route */
export const VALHALLA_OPTIMIZED_ROUTE_ENDPOINT = baseUrl + 'optimized_route'
